import { FETCH_PLAN_RESULT, CREATE_PLAN_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_PLAN_RESULT:
      return { ...state, plan: action.payload };
    case CREATE_PLAN_RESULT:
      return { ...state, reload: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plan.js